import PushNotificationDetailsModal from './PushNotificationDetailsModal';

export default PushNotificationDetailsModal;
